import {
  electricPurple500,
  electricPurple600,
  robotoRegular,
  scarpaGray100,
  scarpaGray500,
  scarpaGray900,
} from '@habitech/shared';
import styled from 'styled-components';

export const WrapperTaskTable = styled.div`
  font-family: ${robotoRegular};
  width: 100%;
  font-size: 15px;
  .headers {
    font-size: 14px;
    font-weight: 900;
  }
  table {
    border: 1px solid rgba(243, 243, 243, 1);
  }
  thead {
    position: sticky;
    top: 0px;
    z-index: 5;
  }
  th {
    padding: 14px !important;
    background: rgba(250, 250, 250, 1);
  }
  .table-scroll {
    overflow: scroll;
    height: calc(100vh - 140px);
  }
  .rows {
    font-size: 13px;
  }
  td {
    padding: 10px !important;
    border-bottom: 1px solid #e6e5e7;
    vertical-align: middle;
  }
  .badge-approver {
    font-weight: 400 !important;
    font-size: 13px;
    background-color: rgba(230, 239, 253, 1) !important;
    color: #1e3a8a !important;
  }
  .wrapper-tasks {
    font-size: 15px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: white;
    border: 1px solid rgba(243, 243, 243, 1);
    position: sticky;
    top: 0;
    height: 56px;
    z-index: 2;
  }
  .tasks {
    background: ${scarpaGray100} !important;
    color: ${scarpaGray900};
  }
  .actions-cell {
    white-space: nowrap;
    width: 1%;
  }
  .btn:disabled {
    color: ${scarpaGray500} !important;
  }
  .btn-habi {
    font-size: 14px;
    font-family: 'Roboto';
    src: url(${robotoRegular}) format('truetype');
    background-color: ${electricPurple500};
    border: none;
    border-radius: 8px;
  }
  .btn-habi:hover {
    background-color: ${electricPurple600};
  }
`;
